// extracted by mini-css-extract-plugin
export default {"inputContainer":"ResetPassword_inputContainer__r40Q7","inputLabel":"ResetPassword_inputLabel__EgCyh","centeredError":"ResetPassword_centeredError__cPek1"};